<template>
  <div
    class="title is-4 mb-4"
    style="white-space: pre-wrap; display: flex; align-items: center"
  >
    <span
      class="hover-allow"
      style="float: left; margin-right: 24px"
      @click="$common.readQuestionLoud(parseText(updatedHtml))"
      ><b-icon icon="volume-high"></b-icon
    ></span>
    <quill-view :data="updatedHtml" />
  </div>
</template>
<script>
import QuillView from "@/components/Editor/QuillView";

export default {
  name: "question-text",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  components: {
    QuillView,
  },
  methods:{
      parseText(html){
        let tempDivElement = document.createElement("div");
        tempDivElement.innerHTML = html;
        return tempDivElement.textContent || tempDivElement.innerText || "";
      }
  },
  computed : {
    updatedHtml(){
      return this.text.replace(/&nbsp;/g, " ");
    }
  }
};
</script>